export default __webpack_public_path__ + "static/media/profile-2.1976e4d0.png";